
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        claim: {
            type: Boolean,
            default: false,
        },
        allowBackButton: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        code: null,
        loadingClaim: false,
        checkModal: false,
        checkData: {},
    }),
    methods: {
        async onClaimPromotionCode() {
            this.loadingClaim = true
            if (!this.code) return (this.loadingClaim = false)
            if (this.code) {
                const res = await this.$store.dispatch(
                    'themes/promotion/claimPromotionCode',
                    { code: this.code?.trim(), walletPopupStatus: 1 }
                )
                if (!res) return (this.loadingClaim = false)
                if (JSON.parse(res?.display_popup) === true) {
                    this.checkData = res
                    this.checkModal = true
                } else if (JSON.parse(res?.display_popup) === false) {
                    this.code = null
                }
                this.loadingClaim = false
            }
        },
    },
}
